import genericGenerator from './Generic';
import productNamingGenerator from './ProductNaming';
import brandAwarenessGenerator from './BrandAwareness';
import brandPerceptionsGenerator from './BrandPerceptions';
import brandDiagnosticGenerator from './BrandDiagnostic';
import productConceptTestingGenerator from './ProductConceptTesting';
import conceptTestingGenerator from './ConceptTesting';
import logoTestingGenerator from './LogoTesting';
import advertisingTestingGenerator from './AdvertisingTesting';
import vanWestendorpGenerator from './VanWestendorp';
import conjointMaxDiffTestingGenerator from './ConjointMaxDiffTesting';
import onlineRetailerPerceptionsTestingGenerator from './OnlineRetailerPerceptionsTesting';
import retailCategoryConvertsionTestingGenerator from './RetailCategoryConversionTesting';
import cpgBrandAwarenessPerceptionsGenerator from './CpgBrandAwarenessPerceptionsTesting';
import cpgStoreChoiceDriversGenerator from './CpgStoreChoiceDriversTesting';
import cpgPathToPurchaseGenerator from './CpgPathToPurchaseTesting';
import { generators } from './constants';

const SURVEY_GENERATORS = {
  [generators.PRODUCT_NAMING]: productNamingGenerator,
  [generators.PRODUCT_CONCEPT_TESTING]: productConceptTestingGenerator,
  [generators.CONCEPT_TESTING]: conceptTestingGenerator,
  [generators.BRAND_AWARENESS]: brandAwarenessGenerator,
  [generators.BRAND_DIAGNOSTIC]: brandDiagnosticGenerator,
  [generators.BRAND_PERCEPTIONS]: brandPerceptionsGenerator,
  [generators.LOGO_TESTING]: logoTestingGenerator,
  [generators.CONJOINT_TESTING]: conjointMaxDiffTestingGenerator,
  [generators.MAXDIFF_TESTING]: conjointMaxDiffTestingGenerator,
  [generators.ADVERTISING_TESTING]: advertisingTestingGenerator,
  [generators.VAN_WESTENDORP_TEMPLATE]: vanWestendorpGenerator,
  [generators.ONLINE_RETAILER_PERCEPTIONS_TESTING]:
    onlineRetailerPerceptionsTestingGenerator,
  [generators.RETAIL_CATEGORY_CONVERSION_TESTING]:
    retailCategoryConvertsionTestingGenerator,
  [generators.CPG_BRAND_AWARENESS_PERCEPTIONS]:
    cpgBrandAwarenessPerceptionsGenerator,
  [generators.CPG_STORE_CHOICE_DRIVERS]: cpgStoreChoiceDriversGenerator,
  [generators.CPG_PATH_TO_PURCHASE]: cpgPathToPurchaseGenerator,
  [generators.GENERIC]: genericGenerator,
};

export default SURVEY_GENERATORS;
